import { Registration } from "./Registration";

export const RegistrationPage = () => {
  return <Registration />;
};
